import { useMutation } from 'react-query'
import { useNavigate, useParams } from 'react-router-dom'

import AuthDataService from 'src/services/auth.service'

import { joinAbsRoute, joinRelRoute } from 'src/common/utils'
import { ROUTES, STORAGE_KEYS } from 'src/constants'

const useEmailVerification = () => {
  const { token } = useParams()
  const navigate = useNavigate()

  return useMutation((code: string) => AuthDataService.verifyEmail(token!, code), {
    onSettled: (data) => {
      if (!data) return

      if (data.accessToken && data.refreshToken) {
        localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, data.accessToken)
        localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, data.refreshToken)
        return navigate(
          data.accountId
            ? joinAbsRoute(ROUTES.ACCOUNTS, data.accountId, ROUTES.DASHBOARD)
            : joinAbsRoute(ROUTES.ACCOUNTS),
        )
      }

      if (!data.agreement && data.registrationToken) {
        return navigate(
          joinRelRoute(
            ROUTES.REGISTER_FINISH,
            `${data.registrationToken}?email=${data.email}&${
              data.withoutAccount ? 'without_account=true' : ''
            }`,
          ),
        )
      }
    },
  })
}

export { useEmailVerification }
